import { ICellProps } from "components/infinite";
import * as React from "react";
import * as siteConfig from "site-config";
import { $, merge } from "glamor";
import { theme } from "styles/theme";
import ContentLoader from "react-content-loader";
import { toDataTest } from "helpers/test";

const FALLBACK_URL = `${siteConfig.default.assetPath}/images/linesheet/placeholder.jpg`;

interface ILinesheetTileProps extends ICellProps {
    brandId: string;
}

const TILE_HEIGHT = 308;
const TILE_WIDTH = 256;
const COVER_IMAGE_WIDTH = 256;
const COVER_IMAGE_HEIGHT = 256;
const TILE_PADDING = 0;

export class ProductCollectionCatalogsTile extends React.PureComponent<ILinesheetTileProps, any> {
    styles = merge(
        {
            height: `${TILE_HEIGHT}px`,
            width: `${TILE_WIDTH}px`,
            cursor: "pointer",
            padding: `${TILE_PADDING}px`,
            transition: "all .2s ease-in-out",
        },
        $(" .catalogImage", {
            height: `${COVER_IMAGE_HEIGHT}px`,
            width: `${COVER_IMAGE_WIDTH}px`,
        }),
        $(" .catalogWithoutImage", {
            // backgroundImage: `url(${FALLBACK_URL})`,
            height: `${COVER_IMAGE_HEIGHT}px`,
            width: `${COVER_IMAGE_WIDTH}px`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundColor: theme.palette.lightGrey,
            borderRadius: "5px",
        })
    );

    constructor(props) {
        super(props);
    }

    render() {
        const { brandId, data } = this.props;
        if (!data || (data && data.brand_id !== brandId)) {
            return (
                <div className="linesheetCell">
                    <ContentLoader height={265} width={320} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
                        <rect x="7" y="19" rx="5" ry="5" width="300" height="200" />
                        <rect x="9" y="227" rx="0" ry="0" width="164" height="25" />
                        <rect x="258" y="242" rx="0" ry="0" width="0" height="0" />
                    </ContentLoader>
                </div>
            );
        }

        const imageUrl = data._portraitImage || data._coverThumb || FALLBACK_URL;

        return (
            <div {...this.styles}>
                <div
                    data-test={`linesheet-${toDataTest(data.title)}`}
                    className="catalogWithImage"
                    style={{ display: "flex" }}
                >
                    <div
                        className="catalogImage"
                        style={{
                            backgroundSize: "cover",
                            backgroundImage: `url(${imageUrl})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundColor: theme.palette.lightGrey,
                            marginRight: "1px",
                        }}
                    />
                </div>
                <div className="title">{data.title}</div>
            </div>
        );
    }
}
